import { useStore } from 'dg-web-shared/lib/Flux';
import * as LayoutState from '../state/LayoutState';
import { responsiveVariant } from '../utils/responsiveVariant';
import { css } from '@emotion/css';

interface ColumnSliderProps {
    children?: React.ReactNode;
}

export function ColumnSlider({ children }: ColumnSliderProps) {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));

    return (
        <div
            className={css([
                {
                    height: '100%',
                },
                responsiveVariant(storeState) === 'Mobile' && {
                    position: 'absolute',
                    width: '100%',
                },
            ])}
        >
            {children}
        </div>
    );
}

interface ColumnSliderColumnProps {
    children?: React.ReactNode;
    index: number;
}

export function ColumnSliderColumn({
    children,
    index,
}: ColumnSliderColumnProps) {
    const { storeState } = useStore(store => ({
        layout: new LayoutState.StateSlice(store).state,
    }));

    return (
        <div
            className={css({
                height: '100%',
                float: 'left',
            })}
            data-index={index}
            data-responsive-variant={responsiveVariant(storeState)}
        >
            {children}
        </div>
    );
}
